import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import HKVDialog from "../../HKVDialog/7.0"
import { DialogFooter } from "../../DialogHeader"

import {
  Button,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material"

import { addLocalStorage } from "../../../store/reducers/localStorage"

import { getAnalyticsId } from "../../../store/environment"

function HKVAnalytics() {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const localStorage = useSelector((state) => state.localStorage)

  const [dialogConfig, setDialogConfig] = useState()

  useEffect(() => {
    const analyticsId = getAnalyticsId()

    switch (localStorage?.consentAnalytics) {
      case "true":
        const script1 = document.createElement("script")
        script1.async = true
        script1.src = `https://www.googletagmanager.com/gtag/js?id=G-${analyticsId}`
        document.head.appendChild(script1)

        const script2 = document.createElement("script")
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || []
          function gtag(){ dataLayer.push(arguments) }
          gtag('js', new Date())
          gtag('config', 'G-${analyticsId}')
        `
        document.head.appendChild(script2)
        break;

      case "false":
        break;

      default:
        openDialog("xs")
        break;
    }
  }, [localStorage?.consentAnalytics])

  const openDialog = (size, options) => {
    const mergedOptions = { ...options, open: true, size: size ? size : "lg" }
    setDialogConfig(mergedOptions)
  }

  const closeDialog = (accepted = true) => {
    dispatch(addLocalStorage({ key: "consentAnalytics", value: accepted.toString() }))
    setDialogConfig()
  }

  return (
    <HKVDialog
      config={dialogConfig}
      onClose={() => closeDialog(true)}
    >
      <DialogTitle>
        {t("Cookies")}
        <img
          src="/static/images/cookies_consent.png"
          title={t("Cookies")}
          alt={t("Cookies")}
          width={32}
          style={{ objectFit: "contain", verticalAlign: "middle", marginLeft: "8px" }}
        />
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
        <Typography sx={{ whiteSpace: "pre-line" }}>{t("Cookie_text")}</Typography>
      </DialogContent>
      {/* Dezelfde knoppenbalk als elke andere dialoog, met de privacyverklaring links. */}
      <DialogFooter>
        <Typography
          variant="caption"
          sx={{ mr: "auto" }}
        >
          <a
            title={t("Privacy_statement")}
            href="https://www.hkv.nl/en/privacy-statement/"
            target="_blank"
            rel="noreferrer"
          >
            {t("Privacy_statement")}
          </a>
        </Typography>
        {/* Weigeren is geen gevaarlijke keuze en hoort er ook niet zo uit te zien. */}
        <Button
          variant="outlined"
          onClick={() => closeDialog(false)}
        >
          {t("Deny")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => closeDialog(true)}
        >
          {t("Accept")}
        </Button>
      </DialogFooter>
    </HKVDialog>
  )
}

export default HKVAnalytics